import $ from 'jquery';

window.jQuery = $;
require('@fancyapps/fancybox');
function captcha() {
    return new Promise(function(resolve, reject) {
      grecaptcha.ready(function() {
        grecaptcha.execute('6LesY-4nAAAAAN1ODjJOuxKcai6CGGEGGDP3q70w', {action: 'submit'}).then(function(token) {
          resolve(token);
        });
      });
    });
}

const forms = {
    formClass : '.form',
    $forms : null,
    floatClass: '.field-2 input, field-3 input',
    $inputs : null,

    init: function(container){
        if(typeof container === 'undefined'){
            container = document;
        }
        let obj = this;
        obj.$forms = $(container).find(obj.formClass);
        if(obj.$forms.length){
            //obj.$forms.on('submit', async function(e){
            obj.$forms.on('submit', function(e){
                e.preventDefault();
               // let token = await captcha();

                let $this = $(this);
                let $btn = $this.find('button[type=submit]');
                //[0].disabled = true;
                //console.log($btn);


                let $msg = $this.find(".form-messages");

                $this
                    .find('.has-error')
                    .removeClass('has-error')
                    .find('.form-field--error')
                    .html('');

                $.ajax({
                    url:$this.attr('action'),
                 //   data: $this.serialize() + '&token='+token,
                    data: $this.serialize(),
                    type: 'POST'
                }).done(function( data ) {
                    console.log(data);
                    if(data.status === 0){
                        $.each(data.errors, function(){
                           $this.find('.form-error--'+this[1]).html(this[0]).parent().addClass('has-error');
                        });
                        $btn[0].disabled = false;
                    }else{
                        $this.find('.form-fields').hide();
                        $this.find('.form-footer').hide();
                        $msg.html(data.message).show();
                    }
                })
            });
            obj.$inputs = obj.$forms.find(obj.floatClass);
            obj.$inputs.on('keyup', function(){
                let $this = $(this);
                if($this.val() === ''){
                    $this.parent().removeClass('floatLabel');
                }else{
                    $this.parent().addClass('floatLabel');
                }
            });
        }
    }

};
const init = () => {
    document.body.style.opacity = '1';

    setTimeout(() => {
        document.querySelectorAll('.reveal').forEach(el => el.classList.remove('reveal'));
        document.querySelectorAll('.stagger-left').forEach(el => el.classList.remove('stagger-left'));
        document.querySelectorAll('.stagger-right').forEach(el => el.classList.remove('stagger-right'));

        setTimeout(() => {

        },1000);
    },720);

    const popupltEl = document.querySelector('.popup.lt');
    const popupczEl = document.querySelector('.popup.cz');

    const popupukEl = document.querySelector('.popup.uk');
    const popuplvEl = document.querySelector('.popup.lv');
    const popupskEl = document.querySelector('.popup.sk');
    const popupplEl = document.querySelector('.popup.pl');
    const popuppl2El = document.querySelector('.popup.pl2');
    const ltEl = document.querySelector('.ltcs');
    const czEl = document.querySelector('.czcs');

    const ukEl = document.querySelector('.ukcs');
    const lvEl = document.querySelector('.lvcs');
    const skEl = document.querySelector('.skcs');
    const plEl = document.querySelector('.plcs');
    const pl2El = document.querySelector('.plcs2');


    const other = document.querySelectorAll('#CZ-zona,' +
        ' #LT-zona,' +
        ' #UK-zona, #PL-zona, #SK-zona, #LV-zona, #UK-zona, #SK-zona');
    const links = document.querySelectorAll('.link a');

    links.forEach(el => {
        el.addEventListener('mouseenter', (e) => {
            var size = popupltEl.getBoundingClientRect();
            var scroll =  window.scrollY;

            if(e.currentTarget.dataset.url === 'lt') {

                let coords = ltEl.getBoundingClientRect();
                popupltEl.style.left = `${coords.left - (size.height / 2) + (coords.height / 2)}px`;
                popupltEl.style.top = `${coords.top + scroll  - (size.height / 2) + (coords.height / 2)}px`;
                popupltEl.classList.add('active');
                ltEl.classList.add('active');
            }

            if(e.currentTarget.dataset.url === 'cz') {
                let coords1 = czEl.getBoundingClientRect();
                console.log(czEl);
                popupczEl.style.left = `${coords1.left - (size.height / 2) + (coords1.height / 2)}px`;
                popupczEl.style.top = `${coords1.top + scroll - (size.height / 2) + (coords1.height / 2)}px`;
                popupczEl.classList.add('active');
                czEl.classList.add('active');
            }

            if(e.currentTarget.dataset.url === 'lv') {
                let coords2 = lvEl.getBoundingClientRect();
                popuplvEl.style.left = `${coords2.left - (size.height / 2) + (coords2.height / 2)}px`;
                popuplvEl.style.top = `${coords2.top + scroll - (size.height / 2) + (coords2.height / 2)}px`;
                popuplvEl.classList.add('active');
                lvEl.classList.add('active');
            }

            if(e.currentTarget.dataset.url === 'uk') {
                let coords3 = ukEl.getBoundingClientRect();
                popupukEl.style.left = `${coords3.left - (size.height / 2) + (coords3.height / 2)}px`;
                popupukEl.style.top = `${coords3.top + scroll - (size.height / 2) + (coords3.height / 2)}px`;
                popupukEl.classList.add('active');
                ukEl.classList.add('active');
            }

            if(e.currentTarget.dataset.url === 'sk') {
                let coords4 = skEl.getBoundingClientRect();
                popupskEl.style.left = `${coords4.left - (size.height / 2) + (coords4.height / 2)}px`;
                popupskEl.style.top = `${coords4.top + scroll - (size.height / 2) + (coords4.height / 2)}px`;
                popupskEl.classList.add('active');
                skEl.classList.add('active');
            }

            if(e.currentTarget.dataset.url === 'pl') {

                let coords5 = plEl.getBoundingClientRect();
                popupplEl.style.left = `${coords5.left - (size.height / 2) + (coords5.height / 2)}px`;
                popupplEl.style.top = `${coords5.top + scroll - (size.height / 2) + (coords5.height / 2)}px`;
                popupplEl.classList.add('active');
                plEl.classList.add('active');

                let coords5_2 = pl2El.getBoundingClientRect();
                popuppl2El.style.left = `${coords5_2.left - (size.height / 2) + (coords5_2.height / 2)}px`;
                popuppl2El.style.top = `${coords5_2.top + scroll - (size.height / 2) + (coords5_2.height / 2)}px`;
                popuppl2El.classList.add('active');
                pl2El.classList.add('active');
            }

        });

        el.addEventListener('mouseleave', (e) => {
            popupczEl.classList.remove('active');
            czEl.classList.remove('active');

            popupltEl.classList.remove('active');
            ltEl.classList.remove('active');

            popuplvEl.classList.remove('active');
            lvEl.classList.remove('active');

            popupukEl.classList.remove('active');
            ukEl.classList.remove('active');

            popupskEl.classList.remove('active');
            skEl.classList.remove('active');

            popupplEl.classList.remove('active');
            plEl.classList.remove('active');

            popuppl2El.classList.remove('active');
            pl2El.classList.remove('active');
        });
    });


    other.forEach(el => {
        el.addEventListener('click', (e) => {
            const lang = e.currentTarget.parentElement.dataset.url;
            document.querySelector(`.link a[data-url="${lang}"`).click();
        });

        el.addEventListener('mouseenter', (e) => {
            const lang = e.currentTarget.parentElement.dataset.url;
           // console.log(lang);
        //    console.log(e.currentTarget.parentElement.dataset.url);
            document.querySelector(`.link a[data-url="${lang}"`).classList.add('active');

            var scroll =  window.scrollY;
            let size = popupltEl.getBoundingClientRect();
          //  console.log(popupltEl);
            if(lang === 'lt') {

                let coords = ltEl.getBoundingClientRect();
                popupltEl.style.left = `${coords.left - (size.height / 2) + (coords.height / 2)}px`;
                popupltEl.style.top = `${coords.top  + scroll - (size.height / 2) + (coords.height / 2)}px`;
                popupltEl.classList.add('active');
                ltEl.classList.add('active');
            }
            if(lang === 'cz'){
                let coords1 = czEl.getBoundingClientRect();
                popupczEl.style.left = `${coords1.left - (size.height / 2) + (coords1.height / 2)}px`;
                popupczEl.style.top = `${coords1.top  + scroll - (size.height / 2) + (coords1.height / 2)}px`;
                popupczEl.classList.add('active');
                czEl.classList.add('active');
            }

            if(lang === 'uk'){
                let coords2 = ukEl.getBoundingClientRect();
                popupukEl.style.left = `${coords2.left - (size.height / 2) + (coords2.height / 2)}px`;
                popupukEl.style.top = `${coords2.top  + scroll - (size.height / 2) + (coords2.height / 2)}px`;
                popupukEl.classList.add('active');
                ukEl.classList.add('active');
            }

            if(lang === 'lv'){
                let coords3 = lvEl.getBoundingClientRect();
                popuplvEl.style.left = `${coords3.left - (size.height / 2) + (coords3.height / 2)}px`;
                popuplvEl.style.top = `${coords3.top + scroll  - (size.height / 2) + (coords3.height / 2)}px`;
                popuplvEl.classList.add('active');
                lvEl.classList.add('active');
            }

            if(lang === 'sk'){
                let coords4 = skEl.getBoundingClientRect();
                popupskEl.style.left = `${coords4.left - (size.height / 2) + (coords4.height / 2)}px`;
                popupskEl.style.top = `${coords4.top + scroll  - (size.height / 2) + (coords4.height / 2)}px`;
                popupskEl.classList.add('active');
                skEl.classList.add('active');
            }

            if(lang === 'pl'){
                let coords5 = plEl.getBoundingClientRect();
                popupplEl.style.left = `${coords5.left - (size.height / 2) + (coords5.height / 2)}px`;
                popupplEl.style.top = `${coords5.top + scroll  - (size.height / 2) + (coords5.height / 2)}px`;
                popupplEl.classList.add('active');
                plEl.classList.add('active');

                let coords5_2 = pl2El.getBoundingClientRect();
                popuppl2El.style.left = `${coords5_2.left - (size.height / 2) + (coords5_2.height / 2)}px`;
                popuppl2El.style.top = `${coords5_2.top + scroll  - (size.height / 2) + (coords5_2.height / 2)}px`;
                popuppl2El.classList.add('active');
                pl2El.classList.add('active');
            }
        });

        el.addEventListener('mouseleave', (e) => {
            links.forEach(el => el.classList.remove('active'));

            popupczEl.classList.remove('active');
            czEl.classList.remove('active');

            popupltEl.classList.remove('active');
            ltEl.classList.remove('active');

            popuplvEl.classList.remove('active');
            lvEl.classList.remove('active');

            popupskEl.classList.remove('active');
            skEl.classList.remove('active');


            popupukEl.classList.remove('active');
            ukEl.classList.remove('active');

            popupplEl.classList.remove('active');
            plEl.classList.remove('active');

            popuppl2El.classList.remove('active');
            pl2El.classList.remove('active');
        });
    });
};

if (document.readyState !== 'loading') {
    init();
} else {
    document.addEventListener('DOMContentLoaded', () => init());
}

$(document).ready(function(){

    forms.init();

});
